import { render } from "./MinhasCampanhas.vue?vue&type=template&id=0b433178&scoped=true&ts=true"
import script from "./MinhasCampanhas.vue?vue&type=script&lang=ts"
export * from "./MinhasCampanhas.vue?vue&type=script&lang=ts"

import "./MinhasCampanhas.vue?vue&type=style&index=0&id=0b433178&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b433178"]])

export default __exports__